import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FieldType, Role, UserType } from 'app/common/enums';
import { CustomHttpParams } from 'app/entities/custom-http-params';
import { OrgUser } from 'app/entities/user';
import { StorageService } from 'app/services/storage.service';
import { SharedModule } from 'app/shared.module';
import { UserQuery } from 'app/state/user';
import * as _ from 'lodash';
import { firstValueFrom } from 'rxjs';

import { Utils } from '../../common/utils';
import { HttpService } from '../../services/http.service';
import { SpinnerModule } from '../spinner/spinner.module';
import { OrgUserDetailsComponent } from '../user-details/org-user-details.component';
import { UserService } from '../user-details/user.service';
import { BaseUsers } from './base-users';

@Component({
    selector: 'app-table-org-users',
    standalone: true,
    imports: [
        CommonModule,
        SpinnerModule,
        MatPaginatorModule,
        MatInputModule,
        MatTableModule,
        SharedModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatSortModule,
    ],
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    providers: [UserService<OrgUser>],
})
export class OrgUsersComponent extends BaseUsers<OrgUser> implements OnInit {
    icon = 'people_outline';
    tableId = 'orgUsersTable';

    constructor(
        protected userQuery: UserQuery,
        router: Router,
        httpService: HttpService,
        dialog: MatDialog,
        storageService: StorageService,
        modalService: NgbModal,
        userService: UserService<OrgUser>,
        private translate: TranslateService
    ) {
        super(userQuery, router, httpService, dialog, storageService, modalService, UserType.OrgUser, userService);
        this.displayedColumns = ['name', 'email', 'activated', 'role', 'lastLogin', 'actions'];
    }

    async ngOnInit() {
        this.cardTitle = await firstValueFrom(this.translate.get('et.organisation'));
        const filterValues = [
            { id: 'role', value: [Role.OrgAdmin], type: FieldType.Dropdown },
            { id: 'organisationId', value: [this.userInfo.organisationId], type: FieldType.Dropdown },
            { id: 'type', value: [UserType.OrgUser], type: FieldType.Dropdown },
        ];
        const userParams: CustomHttpParams = new CustomHttpParams()
            .generateFilters(filterValues)
            .generateFields(['id', 'firstName', 'lastName', 'email', 'title', 'activated', 'role', 'roles', 'lastLogin']);
        this.tableIsLoading = this.userService.getUsers(userParams).then((data: OrgUser[]) => {
            this.users = data;
            this.buildTable(this.users);
        });
    }

    addUser() {
        this.add(OrgUserDetailsComponent);
    }

    editUser(userInfo: number) {
        this.edit(userInfo, OrgUserDetailsComponent);
    }
}
